import { IAutomationObject } from '../../types'

export interface ISP_Pipe extends IAutomationObject {
    isOn: boolean;
    isMan: boolean;
    errSum: boolean;
}

export const schema = 'AutomationApps.SubPlants.Pipes.SP_Pipe';
export const schemaFlow = 'AutomationApps.SubPlants.Pipes.SP_FlowPipe';
export const schemaOutlet = 'AutomationApps.SubPlants.Pipes.SP_OutletPipe';
export const schemaPFlow = 'AutomationApps.SubPlants.Pipes.SP_PrimaryFlowPipe';
export const schemaPOutlet = 'AutomationApps.SubPlants.Pipes.SP_PrimaryOutletPipe';
export const schemaSFlow = 'AutomationApps.SubPlants.Pipes.SP_SecondaryFlowPipe';
export const schemaSOutlet = 'AutomationApps.SubPlants.Pipes.SP_SecondaryOutletPipe';

